module.exports = __webpack_public_path__ + "img/tuijianchapin.b26e0adc.png";